<div id="course-list-filter-holder" class="mb-2 stocky-top">
  <div id="course-list-filter">
    <h3 class="sr-only">Search Courses</h3>
    <form [formGroup]="filterForm">
      <div id="searchbar" class="d-flex">
        <div id="coursefilter-search" class="form-group rounded">
          <input type="text" name="coursefilter-search" formControlName="text:search"
            placeholder="Search course titles, instructors, and descriptions" class="w-100 h-100 pl-2" />
        </div>
        <div id="advanced-search-toggle">
          <a href="#" (click)="toggleFilterDisplay();" class="d-block" title="{{courseFilterService.showFilterUI ? 'Hide' : 'Show' }} course filter">
            <span class="d-block d-md-none">
              <fa-icon icon="filter" size="md"></fa-icon>
            </span>
            <span class="d-none d-md-block">Filter
              <fa-icon *ngIf="!courseFilterService.showFilterUI" icon="caret-down" size="lg" class="ml-2"></fa-icon>
              <fa-icon *ngIf="courseFilterService.showFilterUI" icon="caret-up" size="lg" class="ml-2"></fa-icon>
            </span>
          </a>
        </div>
        <div id="app-view-options-holder" class="pl-2">
          <app-view-options></app-view-options>
        </div>
      </div>

      <div id="advanced-search-container" class="p-2" [ngClass]="{'d-none' : !courseFilterService.showFilterUI}">
        <div class="d-block d-md-none text-dark text-center"><small>Click the <fa-icon icon="filter"
              size="md"></fa-icon> to hide filter options <fa-icon icon="level-up-alt" size="md"></fa-icon></small>
        </div>
        <h3 tabindex="0">Filter courses by:</h3>
        <button class="sr-only" (click)="toggleScreenreader()">{{ screenreaderActive ? 'Disable' : 'Enable' }} screenreader compatibility</button>
        <div ngbDropdown #ltdrop="ngbDropdown" class="d-inline-block mx-2 mb-2">
          <button
            [ngClass]="{'btn': true, 'btn-outline-primary': activeFilters.Types, 'btn-outline-secondary': !activeFilters.Types }"
            id="filter-course-type" ngbDropdownToggle>
            <span class="d-none d-md-inline-block">Library / Course Type</span>
            <span class="d-inline-block d-md-none">Library / Type</span>
          </button>
          <div ngbDropdownMenu aria-labelledby="filter-course-type" class="dropdown-menu py-0">
            <ul class="list-group library">
              <ng-container *ngFor="let courseLibrary of courseLibraries">
                <li class="list-group-item pr-0 pb-0">
                  <div class="d-flex justify-content-between pr-3">
                    <label class="filter-check" for="library:{{courseLibrary.Name}}">
                        <input type="checkbox" class="{{screenreaderActive ? 'srvisible' : ''}}" formControlName="library:{{courseLibrary.Name}}"
                          id="library:{{courseLibrary.Name}}" title="Course library: {{courseLibrary.Name}}" />
                      <fa-icon *ngIf="!libraryIndeterminateState[courseLibrary.Name]" [icon]="['far','square']"
                        class="fa-lg unchecked"></fa-icon>
                      <fa-icon *ngIf="!libraryIndeterminateState[courseLibrary.Name]" [icon]="['far','check-square']"
                        class="fa-lg checked"></fa-icon>
                      <fa-icon *ngIf="libraryIndeterminateState[courseLibrary.Name]" [icon]="['far','minus-square']"
                        class="fa-lg"></fa-icon>
                      {{courseLibrary.Name}}
                    </label>
                    <fa-icon [icon]="['far', 'question-circle']" class="fa-lg text-secondary" title="{{libraryTipText[courseLibrary.Name]}}"
                      ngbTooltip="{{libraryTipText[courseLibrary.Name]}}" container="body" tabindex="0"></fa-icon>
                  </div>
                  <ul class="list-group type">
                    <ng-container *ngFor="let courseType of courseTypes">
                      <ng-container *ngIf="courseLibrary.Types.includes(courseType.TypeID)">
                        <li
                          class="list-group-item d-flex justify-content-between align-items-center border-left-0 border-right-0 border-bottom-0 border-top">
                          <label class="filter-check" for="type:{{courseType.TypeID}}">
                            <input type="checkbox" class="{{screenreaderActive ? 'srvisible' : ''}}" formControlName="type:{{courseType.TypeID}}"
                              id="type:{{courseType.TypeID}}" title="Course type: {{courseLibrary.Name}} {{courseType.Name}} ({{courseType.CourseCount}} courses of this type)" />
                            <fa-icon [icon]="['far','square']" class="fa-lg unchecked"></fa-icon>
                            <fa-icon [icon]="['far','check-square']" class="fa-lg checked"></fa-icon>
                            {{courseType.Name}}
                          </label>
                          <span class="badge badge-primary badge-pill">{{courseType.CourseCount}}</span>
                        </li>
                      </ng-container>
                    </ng-container>
                  </ul>
                </li>
              </ng-container>

              <li class="list-group-item d-flex justify-content-between align-items-center"><a href="#"
                  (click)="SetAll('type', true);">Check All</a><a href="#" (click)="SetAll('type', false);">Clear
                  All</a></li>
            </ul>
          </div>
        </div>

        <div ngbDropdown class="d-inline-block mx-2 mb-2">
          <button
            [ngClass]="{'btn': true, 'btn-outline-primary': activeFilters.Tags, 'btn-outline-secondary': !activeFilters.Tags }"
            id="filter-course-tags" ngbDropdownToggle>Course Category</button>
          <div ngbDropdownMenu aria-labelledby="filter-course-tags" class="dropdown-menu py-0">
            <ul class="list-group">
              <ng-container *ngFor="let courseTag of courseTags">
                <li class="list-group-item d-flex justify-content-between align-items-center">
                  <label class="filter-check" for="tag:{{courseTag.Name}}">
                    <input type="checkbox" class="{{screenreaderActive ? 'srvisible' : ''}}" formControlName="tag:{{courseTag.Name}}" id="tag:{{courseTag.Name}}" title="({{courseTag.CourseCount}} courses of this category)" />
                    <fa-icon [icon]="['far','square']" class="fa-lg unchecked"></fa-icon>
                    <fa-icon [icon]="['far','check-square']" class="fa-lg checked"></fa-icon>
                    {{courseTag.Name}}
                  </label>
                  <span class="badge badge-primary badge-pill">{{courseTag.CourseCount}}</span>
                </li>
              </ng-container>
              <li class="list-group-item d-flex justify-content-between align-items-center"><a href="#"
                  (click)="SetAll('tag', true);">Check All</a><a href="#" (click)="SetAll('tag', false);">Clear All</a>
              </li>
            </ul>
          </div>
        </div>

        <div ngbDropdown class="d-inline-block mx-2 mb-2" *ngIf="lmsUserService.IsLoggedIn">
          <button
            [ngClass]="{'btn': true, 'btn-outline-primary': activeFilters.Statuses, 'btn-outline-secondary': !activeFilters.Statuses }"
            id="filter-course-status" ngbDropdownToggle>Course Status</button>
          <div ngbDropdownMenu aria-labelledby="filter-course-status" class="dropdown-menu py-0">
            <ul class="list-group">
              <ng-container *ngFor="let courseStatus of courseStatuses">
                <li class="list-group-item d-flex justify-content-between align-items-center">
                  <label class="filter-check" for="status:{{courseStatus.Name}}">
                    <input type="checkbox" class="{{screenreaderActive ? 'srvisible' : ''}}" formControlName="status:{{courseStatus.Name}}"
                      id="status:{{courseStatus.Name}}" title="({{courseStatus.CourseCount}} courses with this status)" />
                    <fa-icon [icon]="['far','square']" class="fa-lg unchecked"></fa-icon>
                    <fa-icon [icon]="['far','check-square']" class="fa-lg checked"></fa-icon>
                    {{courseStatus.Name}}
                  </label>
                  <span class="badge badge-primary badge-pill">{{courseStatus.CourseCount}}</span>
                </li>
              </ng-container>
              <li class="list-group-item d-flex justify-content-between align-items-center"><a href="#"
                  (click)="SetAll('status', true);">Check All</a><a href="#" (click)="SetAll('status', false);">Clear
                  All</a></li>
            </ul>
          </div>
        </div>

        <div ngbDropdown class="d-inline-block mx-2 mb-2">
          <button
            [ngClass]="{'btn': true, 'btn-outline-primary': activeFilters.Credits, 'btn-outline-secondary': !activeFilters.Credits }"
            id="filter-course-credits" ngbDropdownToggle>CE Hours</button>
          <div ngbDropdownMenu aria-labelledby="filter-course-credits" class="dropdown-menu py-0">
            <ul class="list-group">
              <ng-container *ngFor="let courseCredit of courseCredits">
                <li class="list-group-item d-flex justify-content-between align-items-center">
                  <label class="filter-check" for="credits:{{courseCredit.Name}}">
                    <input type="checkbox" class="{{screenreaderActive ? 'srvisible' : ''}}" formControlName="credits:{{courseCredit.Name}}"
                      id="credits:{{courseCredit.Name}}" title="({{courseCredit.CourseCount}} courses with {{courseCredit.Name}})" />
                    <fa-icon [icon]="['far','square']" class="fa-lg unchecked"></fa-icon>
                    <fa-icon [icon]="['far','check-square']" class="fa-lg checked"></fa-icon>
                    {{courseCredit.Name}}
                  </label>
                  <span class="badge badge-primary badge-pill">{{courseCredit.CourseCount}}</span>
                </li>
              </ng-container>
              <li class="list-group-item d-flex justify-content-between align-items-center"><a href="#"
                  (click)="SetAll('credits', true);">Check All</a><a href="#" (click)="SetAll('credits', false);">Clear
                  All</a></li>
            </ul>
          </div>
        </div>

        <div class="mt-2">
          <label class="filter-check mx-2 blue" for="misc:faves" *ngIf="lmsUserService.IsLoggedIn">
            <input type="checkbox" class="{{screenreaderActive ? 'srvisible' : ''}}" formControlName="misc:faves" id="misc:faves" />
            <fa-icon [icon]="['far','square']" class="fa-lg unchecked"></fa-icon>
            <fa-icon [icon]="['far','check-square']" class="fa-lg checked"></fa-icon>
            Only show my bookmarks
          </label>

          <label class="filter-check mx-2 blue" for="misc:paid"
            *ngIf="lmsUserService.IsLoggedIn && ucdService.HasPaidCourses">
            <input type="checkbox" class="{{screenreaderActive ? 'srvisible' : ''}}" formControlName="misc:paid" id="misc:paid" />
            <fa-icon [icon]="['far','square']" class="fa-lg unchecked"></fa-icon>
            <fa-icon [icon]="['far','check-square']" class="fa-lg checked"></fa-icon>
            Only show my purchased courses
          </label>

          <ng-container *ngIf="lmsUserService.IsLoggedIn && lmsUserService.User.GetApprovalStates().length > 0">
            <span class="blue ml-4">Only show courses approved in: </span>
            <ng-container *ngFor="let aState of lmsUserService.User.GetApprovalStates()">
              <label class="filter-check mr-2 blue" for="misc:approvedstates_{{aState}}">
                <input type="checkbox" class="{{screenreaderActive ? 'srvisible' : ''}}" formControlName="misc:approvedstates_{{aState}}"
                  id="misc:approvedstates_{{aState}}" />
                <fa-icon [icon]="['far','square']" class="fa-lg unchecked"></fa-icon>
                <fa-icon [icon]="['far','check-square']" class="fa-lg checked"></fa-icon>
                {{aState}}
              </label>
            </ng-container>
          </ng-container>
        </div>
      </div>

    </form>

  </div>
</div>